<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="厂商用户管理" :visible.sync="visible" width="70%"
      :before-close="handleClose" destroy-on-close>
      <div>
        <div class="mr-t15 flex flex-row-between">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="账号">
              <el-input v-model="searchForm.keywords" placeholder="請輸入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="用戶帳號">
              <el-input v-model="searchForm.username" placeholder="請輸入"></el-input>
            </el-form-item> -->
            <el-form-item label="創建日期">
              <el-date-picker v-model="searchForm.createAt" :default-time="['00:00:00','23:59:59']" type="datetimerange"
                range-separator="至" start-placeholder="開始日期" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="結束日期">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="角色名稱">
              <el-select v-model="searchForm.role">
                <el-option v-for="(item,index) in roleList" :key="index" :label="item.role_name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" @click="doSearch">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="doReset">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-has="'addAdminuser'" type="primary" @click="showCreate"><i
                  class="el-icon-plus"></i>新增</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-upload
              :limit='1'
                :action="actionFile"
               :on-success="successFile"
               :on-error="errorFile"
               :on-progress="progressFile"
              > -->
            <!-- <el-button  type="primary">導入</el-button> -->
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- </el-upload> -->
            <!-- <el-button v-has="'importt'" el-upload type="warning"  @click="importt">導入</el-button> -->
            </el-form-item>
          </el-form>
        </div>

        <div>
          <el-table v-loading="loading" :border="true" :data="dataList" style="width: 100%">

            <el-table-column align="center" prop="username" label="帳號" width="150">
            </el-table-column>


            <el-table-column align="center" prop="validAt" label="有效日期" width="200">
            </el-table-column>

            <el-table-column align="center" prop="mac" label="設備mac" width="200">
             </el-table-column>

             <el-table-column align="center" prop="status" label="是否可訪問後臺" width="200">
               <template slot-scope="scope">
                 <el-switch @change="typeChange(scope.row)" v-model="scope.row.type" active-value="1"
                   inactive-value="0"></el-switch>
               </template>
             </el-table-column>


            <el-table-column align="center" prop="status" label="狀態" width="130">
              <template slot-scope="scope">
                <el-switch @change="statusChange(scope.row)" v-model="scope.row.status" active-value="1"
                  inactive-value="0"></el-switch>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="createAt" label="創建時間">
            </el-table-column>
            <el-table-column align="center" label="操作" width="250" fixed="right">
              <template slot-scope="scope">
                <div class="flex flex-row-center">
                  <div>
                    <el-button size="mini" v-has="'editAdminuser'" type="primary" @click="edit(scope.row)">編輯</el-button>
                  </div>
                  <div class="mr-l15">
                    <el-button size="mini" v-has="'delAdminuser'" type="danger" @click="del(scope.row)">刪除</el-button>
                  </div>
                  <div class="mr-l15">
                    <el-button size="mini" v-has="'resetAdmin'" type="warning"
                      @click="reset(scope.row)">重置密碼</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="mr-t20 flex flex-row-end">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10,20,40,60,80,100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="dataObj.total">
          </el-pagination>
        </div>


      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose">取 消</el-button> -->
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 新增-->
    <CreateModal @ok="createOk" ref="createModal"></CreateModal>
    <!-- 修改 -->
    <EditModal @ok="editOk" ref="editModal"></EditModal>


  </div>
</template>

<script>
  import CreateModal from "@/views/settings/admin/adminuser/createModal"
  import EditModal from "@/views/settings/admin/adminuser/editModal"
  export default {
    components: {
      CreateModal,
      EditModal
    },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        searchForm: {
          keywords: "",
          username: '',
          createAt: [],
        },
        currentPage: 1,
        pageSize: 10,
        dataList: [],
        dataObj: {},
        visible: false,
        loading: true,
        adminId: '',
      }
    },
    created() {},
    methods: {
      reset(row) {
        this.$confirm('是否将密码重置为123456吗?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$request({
            url: this.$api.admin.resetPassword,
            data: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.resetGetList();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => {
            this.$message.error("请求失败");
          })
        }).catch(() => {

        });
      },
      //删除
      del(row) {
        this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$request({
            url: this.$api.adminuser.delete,
            method: "post",
            data: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.resetGetList();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => {
            this.$message.error("请求失败");
          })
        }).catch(() => {

        });
      },
      //重置搜索加载列表
      resetGetList() {
        this.currentPage = 1;
        this.pageSize = 10;
        this.searchForm = {
          keywords: "",
          username: '',
          createAt: [],
        };
        this.getList();
      },
      // 搜索
      doSearch() {
        this.getList();
      },
      //重置搜索
      doReset() {
        this.resetGetList();
      },
      //切换页码
      handleCurrentChange(e) {
        this.currentPage = e;
        this.getList();
      },
      // 页码大小改变
      handleSizeChange(e) {
        this.pageSize = e;
        this.getList();
      },
      handleClose() {
        this.visible = false
      },
      getData(val) {
        this.form = {
          ...val
        }
        this.adminId = val.id
        this.getList()

      },
      createOk(){
        this.getList()
      },
      editOk(){
        this.getList()
      },
      //修改狀態
      statusChange(row) {
        this.$request({
          url: this.$api.admin.updateStatus,
          method: "post",
          data: {
            id: row.id,
            status: row.status
          }
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(() => {
          this.$message.error("请求失败");
        })
      },

      //修改狀態
      typeChange(row) {
        this.$request({
          url: this.$api.adminuser.typeStatus,
          method: "post",
          data: {
            id: row.id,
            type: row.type
          }
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(() => {
          this.$message.error("请求失败");
        })
      },
      //显示新增dialog
      showCreate() {
        let adminId = this.adminId
         this.$refs.createModal.getDataD(adminId);
        this.$refs.createModal['visible'] = true;

      },
      //传值并且打开修改dialog
      edit(row) {
        this.$refs.editModal.getDataD(row);
        this.$refs.editModal['visible'] = true;
      },
      //获取列表
      getList() {
        this.loading = true;
        this.$request({
          url: this.$api.adminuser.index,
          data: {
			page:this.currentPage,
			pageSize:this.pageSize,
            adminId: this.adminId,
            keywords: this.searchForm.keywords,
            createAt: this.searchForm.createAt,
          }
        }).then((res) => {
          if (res.data.code == 1) {
            this.dataObj = res.data.data;
            this.dataList = res.data.data.data;
            this.loading = false;
          } else {
            this.$message.error(res.data.msg);
          }
        })
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/admin/adminuser/AdminuserModal.vue